<template>
    <v-dialog
        v-model="dialog"
        max-width="720"
    >
      <template v-slot:activator="{ props: activatorProps }">
        <v-btn
          prepend-icon="mdi-plus"
          color="primary"
          text="Nova Opção"
          variant="tonal"
          v-bind="activatorProps"
        />
      </template>
  
      <v-card
          prepend-icon="mdi-plus"
          title="Adicionar Item Formulário"
      >
        <v-card-text>
          <v-row align="center">
            <v-col
                cols="12"
                md="6"
                sm="6"
            >
              <v-text-field
                  v-model="form.description"
                  label="Descrição*"
                  type="text"
                  hide-details
              ></v-text-field>
            </v-col>
            <v-col
                cols="12"
                md="6"
                sm="6"
            >
              <v-select
                  v-model="form.type"
                  :items="Object.values(GENERAL_OPTIONS)"
                  item-title="label"
                  item-value="id"
                  label="Tipo"
                  :readonly="!allowTypeEdit"
                  hide-details
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
  
        <v-divider></v-divider>
  
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              text="Cancelar"
              variant="plain"
              @click="closeDialog"
          ></v-btn>
  
          <v-progress-circular
              v-if="waitingServer"
              color="primary"
              indeterminate
          />
  
          <v-btn
              v-else
              color="primary"
              text="Adicionar"
              variant="tonal"
              :disabled="!form.description || !form.type"
              @click="onCreate"
          ></v-btn>
        </v-card-actions>
      </v-card>
  
      <!-- Snackbar -->
      <v-snackbar
          v-model="snackbar.active"
          :timeout="4000"
          :color="snackbar.color"
          elevation="24"
      >
        {{ snackbar.text }}
      </v-snackbar>
    </v-dialog>
  </template>
  
  <script>
  import { mapActions, mapState } from 'vuex';
  import { GENERAL_OPTIONS } from "@/helpers/constants/app.constants";
  
  export default {
    name: 'FormFieldDialog',
  
    props: {
      formField: {
        type: Object,
        default: null
      },
  
      type: {
        type: String,
        default: GENERAL_OPTIONS.PAYMENT_METHOD.id
      },
  
      allowTypeEdit: {
        type: Boolean,
        default: false
      }
    },
  
    data: () => ({
      dialog: false,
      waitingServer: false,
      editMode: false,
      snackbar: {
        active: false,
        color: '',
        text: ''
      },
  
      form: {
        id: undefined,
        description: '',
        type: '',
      },
    }),
  
    computed: {
      ...mapState('formField', ['formFieldList']),
  
      GENERAL_OPTIONS() {
        return GENERAL_OPTIONS;
      }
    },
  
    watch: {
      dialog(newValue) {
        this.form.type = this.type;
  
        if (!newValue) {
          this.form.description = null;
          this.form.type = null;
          this.waitingServer = false;
          this.editMode = false;
        }
      },
  
      formField(newValue) {
        if (newValue) {
          this.form.id = newValue.id;
          this.form.description = newValue.title;
          this.form.type = GENERAL_OPTIONS[newValue.type];
          this.editMode = true;
        }
      }
    },
  
    methods: {
      ...mapActions('general', ['addGeneral', 'updateGeneral']),
  
      async onCreate() {
        this.waitingServer = true;
        const { success } = this.editMode ? await this.updateGeneral(this.form) : await this.addGeneral(this.form);
  
        success
            ? this.snackbarHandler({color: 'green', text: this.editMode ? 'Item atualizado com sucesso' : 'Item criado com sucesso'})
            : this.snackbarHandler({color: 'red', text: this.editMode ? 'Erro ao atualizar item' : 'Erro ao criar item'})
  
        await this.$nextTick();
  
        this.closeDialog();
      },
  
      closeDialog() {
        this.dialog = false;
        this.waitingServer = false;
      },
  
      snackbarHandler({color, text}) {
        this.snackbar.color = color;
        this.snackbar.text = text;
        this.snackbar.active = true;
      }
    }
  }
  </script>